import { Pause, Play } from 'lucide-react';

import { cn } from '@/lib/utils';
import PlaybackProgress from '@/components/PlaybackProgress';

interface Props {
  /** The player id of the sound (`discover-12`, `reco-…`). */
  audioId: string;
  /** 44 px on the feed card (Home), 40 px on the share screen (Recommander). */
  size: 40 | 44;
  playing: boolean;
  /** No preview to play: the button stays visible, dimmed and inert. */
  disabled?: boolean;
  onToggle: () => void;
  testId: string;
  /** Placement only (`tw:absolute tw:bottom-2 tw:right-2`). */
  className?: string;
}

/**
 * The round play / pause on a cover — the Home feed card and the share screen
 * used the same button twice; one component now, with the playback progress
 * ring around it (playback-progress-ring, maquette C).
 */
export default function RoundPlayButton({
  audioId,
  size,
  playing,
  disabled = false,
  onToggle,
  testId,
  className,
}: Props) {
  const iconSize = size === 44 ? 20 : 18;
  return (
    <div className={cn('tw:relative', size === 44 ? 'tw:size-11' : 'tw:size-10', className)}>
      <PlaybackProgress audioId={audioId} shape="circle" size={size} />
      <button
        type="button"
        onClick={onToggle}
        disabled={disabled}
        aria-label={playing ? 'Pause' : 'Play'}
        data-testid={testId}
        className={cn(
          'tw:flex tw:size-full tw:items-center tw:justify-center tw:rounded-full tw:bg-black/55 tw:text-white tw:backdrop-blur-sm',
          disabled && 'tw:opacity-40',
        )}
      >
        {playing ? (
          <Pause size={iconSize} fill="currentColor" />
        ) : (
          <Play size={iconSize} fill="currentColor" />
        )}
      </button>
    </div>
  );
}
